import React, { Component } from 'react'

import EditableLabel from '../common/EditableLabel'
import ElementContainer from '../common/ElementContainer'
import { faFile } from '@fortawesome/free-solid-svg-icons'

import './File.css'

export default class File extends Component {
  static weight = 1

  static defaultConfig = {
    id: 0,
    type: 'File',
    label: 'File'
  }

  static metaData = {
    icon: faFile,
    displayText: 'File',
    group: 'inputElement'
  }

  static submissionHandler = {
    findQuestionValue: (inputs, qid) => {
      let valueObject = {}
      for (const elem of inputs) {
        if (elem.q_id === qid && elem.value) {
          valueObject[elem.sub_id] = elem.value
        }
      }
      return valueObject
    }
  }
  static getPlainStringValue(entry) {
    let plainString
    if (entry.value !== '') {
      plainString = Object.entries(entry.value)
        .map(([, t]) => `${t}`)
        .filter((text) => text.trim() !== '')
        .join(' ')
    } else {
      plainString = '-'
    }
    return plainString
  }

  static renderDataValue(entry, question) {
    return (
      Object.entries(entry.value).map((entry) => {
        const key = entry[0]
        const value = entry[1]

        let defaultSublabel = true

        if (question[`${key}SublabelText`]) {
          defaultSublabel = false
        }

        return (
          <div key={key}>
            <strong
              style={defaultSublabel ? { textTransform: 'capitalize' } : null}>
              {defaultSublabel
                ? key.replace(/([a-z])([A-Z])/g, '$1 $2')
                : question[`${key}SublabelText`]}
              :
            </strong>
            {value}
            <br />
          </div>
        )
      }) || '-'
    )
  }

  static helpers = {
    getElementValue: (id) => {
      const input = document.getElementById(`q_${id}`)
      return input.files && input.files.length > 0 ? input.files[0] : ''
    },
    isFilled: (value) => value !== '' && value != null,
    isValid: (value) => {
      const maxFileSizeBytes =
        parseFloat(window.MAX_FILE_SIZE_BYTES) || 2.5 * 1024 * 1024
      return value === '' || value == null || value.size <= maxFileSizeBytes
    }
  }

  render() {
    const { config, mode } = this.props
    const inputProps = {}

    if (typeof config.value !== 'undefined') {
      inputProps.value = config.value
    }

    if (typeof this.props.onChange !== 'undefined') {
      inputProps.onChange = this.props.onChange
    }

    if (typeof config.placeholder !== 'undefined') {
      inputProps.placeholder = config.placeholder
    }

    if (typeof config.maxLength !== 'undefined') {
      inputProps.maxLength = config.maxLength
    }
    let script

    if (mode === 'renderer') {
      let scriptInnerHtml = `
     ( () => {
      const fileInput = document.getElementById('q_${config.id}');
      const fileInputHidden = document.getElementById('q_${config.id}-file');
      const fileInputHiddenFilename = document.getElementById('q_${config.id}-filename');
      fileInput.addEventListener('change', (e) => {
        const file = e.target.files[0];
        fileInputHiddenFilename.value = file.name;
        fileInputHidden.files = e.target.files;

      });
      })();
    `
      script = (
        <script key={5} dangerouslySetInnerHTML={{ __html: scriptInnerHtml }} />
      )
    }

    return (
      <ElementContainer type={config.type} {...this.props}>
        <div className="elemLabelTitle">
          <EditableLabel
            className="fl label"
            dataPlaceholder="Type a question"
            mode={mode}
            labelKey={config.id}
            handleLabelChange={this.props.handleLabelChange}
            value={config.label}
            required={config.required}
          />
        </div>
        <div className="fl input">
          <input id={`q_${config.id}`} type="file" />
          <input
            id={`q_${config.id}-file`}
            name={`q_${config.id}[file]`}
            {...inputProps}
            type="file"
            hidden
          />
          <input
            id={`q_${config.id}-filename`}
            name={`q_${config.id}[filename]`}
            {...inputProps}
            hidden
          />
        </div>
        {mode === 'viewer' ? (
          ''
        ) : (
          <div className="clearfix">
            <EditableLabel
              className="sublabel"
              dataPlaceholder="Click to edit sublabel"
              mode={mode}
              labelKey={`sub_${config.id}_address]`}
              handleLabelChange={this.props.handleLabelChange}
              value={
                typeof config.sublabelText !== 'undefined' &&
                config.sublabelText !== ''
                  ? config.sublabelText
                  : ''
              }
            />
          </div>
        )}
        <div className="fl metadata">
          <div className="requiredErrorText">{config.requiredText}</div>
          <div className="invalidErrorText">
            Le fichier sélectionné est trop volumineux.
          </div>
        </div>
        {script && script}
      </ElementContainer>
    )
  }
}
